import { call } from "redux-saga/effects";

import API from "modules/api/api";
import { composeSaga, withErrorHandling } from "modules/root/saga-helpers";

function* submitDiagnosticSessionAnswerImpl(answers, step, diagnosticId) {
  return yield call(
    API.diagnostic.submitDiagnosticSessionAnswer,
    answers,
    step,
    diagnosticId
  );
}

export const submitDiagnosticSessionAnswer = composeSaga(
  withErrorHandling,
  submitDiagnosticSessionAnswerImpl
);

function* fetchPainAreasImpl(view) {
  return yield call(API.diagnostic.getPainAreas, view);
}

export const fetchPainAreas = composeSaga(
  withErrorHandling,
  fetchPainAreasImpl
);

function* unblockDiagnosticImpl(diagId) {
  return yield call(API.diagnostic.unblockDiagnosticSession, diagId);
}

export const unblockDiagnostic = composeSaga(
  withErrorHandling,
  unblockDiagnosticImpl
);

function* fetchDiagnosticImpl(diagId) {
  return yield call(API.diagnostic.getDiagnostic, diagId);
}

export const fetchDiagnostic = composeSaga(
  withErrorHandling,
  fetchDiagnosticImpl
);

function* fetchDiagnosticSessionAnswersImpl(diagId) {
  return yield call(API.diagnostic.getDiagnosticSessionAnswers, diagId);
}

export const fetchDiagnosticSessionAnswers = composeSaga(
  withErrorHandling,
  fetchDiagnosticSessionAnswersImpl
);

function* fetchQuestionImpl(id) {
  return yield call(API.diagnostic.getQuestion, id);
}

export const fetchQuestion = composeSaga(withErrorHandling, fetchQuestionImpl);

function* createDiagnosticImpl(userId, answers) {
  return yield call(API.diagnostic.createDiagnostic, {
    user_id: userId,
    type: "diagnostic",
    answers
  });
}

export const createDiagnostic = composeSaga(
  withErrorHandling,
  createDiagnosticImpl
);



// WEBPACK FOOTER //
// ./src/modules/diagnostic/diagnostic-api-saga.js